<template>
  <div class="page-container">
    <div class="page-card">
      <div class="page-card__header">
        <h1 class="section-title">机构动态</h1>
      </div>
      <div class="page-card__body">
        <div v-for="item in tableData" :key="item.id" class="article-row">
          <RouterLink
            v-if="item.content"
            :to="'/detail?id=' + item.id"
            class="article-row__title"
          >{{ item.title }}</RouterLink>
          <a v-else :href="item.linkUrl" target="_blank" class="article-row__title">{{ item.title }}</a>
          <span class="article-row__date">{{ item.publishDate }}</span>
        </div>
        <div v-if="!tableData.length" class="empty-tip">暂无数据</div>
        <div class="pagination-wrap">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :current-page="pageNo"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { organStatus } from '@/api/cmsApi'

export default {
  name: 'OrganDynamic',
  data() {
    return {
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.query()
  },
  methods: {
    query() {
      organStatus({ pageNo: this.pageNo, pageSize: this.pageSize }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records
          this.total = res.data.total
        }
      })
    },
    handleCurrentChange(page) {
      this.pageNo = page
      this.query()
    }
  }
}
</script>

<style scoped>
.empty-tip {
  text-align: center;
  color: var(--color-text-muted);
  padding: 40px 0;
}
</style>
